/** Notification and approval rows in the search hub. */
export default {
  needsYou: "Needs you",
  today: "Today",
  earlier: "Earlier",
  times: { one: "{count} time", other: "{count} times" },
  gotIt: "Got it",
  clear: "Clear",
  allow: "Allow",
  deny: "Deny",
  markAllRead: "Mark all read",
  clearAll: "Clear all",
} as const;
